import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  arroundIcon: {
    backgroundColor: 'white',
    margin: 5,
    marginLeft: 0,
    padding: UNIT * 0.5,
    borderRadius: UNIT * 0.625
  },
  boldText: {
    fontSize: UNIT,
    fontWeight: 'bolder'
  },
  driverIcon: {
    margin: 5,
    marginLeft: 0,
    borderRadius: UNIT * 0.625,
    border: '2px solid',
    backgroundColor: 'white',
    padding: UNIT * 0.375,
    borderColor: mainColor.secondaryColor
  },
  root: {
    width: '100%',
    borderTop: `0.1px solid ${mainColor.colorAdditional}`
  },
  paperStyle: {
    marginTop: '0px',
    padding: UNIT * 1.25,
    width: '100%'
  },
  addIcon: { marginRight: UNIT * 0.375 },
  iconStyle: {
    width: UNIT * 1.5,
    height: UNIT * 1.5,
    align: 'center',
    color: mainColor.colorWhite,
    backgroundColor: mainColor.secondaryColor
  },
  removeIcon: {
    width: UNIT,
    height: UNIT,
    marginBottom: UNIT * 0.2375
  },
  headerFee: {
    fontWeight: 'normal',
    fontSize: UNIT * 0.6875,
    color: mainColor.colorBlack
  },
  switch: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    margin: '0px'
  },
  itemtext: { paddingLeft: UNIT * 0.3125 },
  disabledStyle: {
    pointerEvents: 'none',
    opacity: 0.7
  }
});
